// extracted by mini-css-extract-plugin
export var arrows = "_1x-5";
export var decrementer = "_1x-9";
export var disabled = "_1x-3";
export var error = "_1x-1";
export var hiddenText = "_1x-a";
export var incrementer = "_1x-8";
export var input = "_1x-7";
export var inputWrapper = "_1x-0";
export var leadingIcon = "_1x-b";
export var readonly = "_1x-2";
export var regular = "_1x-6";
export var small = "_1x-4";